/*
 * Registry of deep-linkable chat agents. Each agent maps to the BFF endpoint that
 * proxies to its (separate) Azure Function App. Note: access gating is currently
 * hard-coded to the Field Pro Coaching entitlement in AgentChatStore.init(), so adding
 * a second agent also requires generalizing that check (e.g. per-agent config here).
 */
export interface AgentConfig {
    endpoint: string;
}

export const AGENTS = {
    'field-pro': { endpoint: '/api/v1/field-pro/chat' },
} as const satisfies Record<string, AgentConfig>;

export type AgentName = keyof typeof AGENTS;

export const isKnownAgent = (name: string): name is AgentName => name in AGENTS;
